// extracted by mini-css-extract-plugin
export default {"demo-app":"CalendarComponent_demo-app__E6IW+","demo-app-main":"CalendarComponent_demo-app-main__q0ZFl","fc":"CalendarComponent_fc__j1LsV"};